import { Route } from "react-router-dom";
import { ShowProvider } from "../../../providers";
import { ChampionAnimationPage } from "../ChampionAnimationPage/ChampionAnimationPage";

const championAnimationRoutes = [
  <Route
    key={"champions-animation"}
    path="champions-animation"
    element={
      <ShowProvider>
        <ChampionAnimationPage />
      </ShowProvider>
    }
  />,
];

export const CHAMPION_ANIMATION_ROUTES = championAnimationRoutes.map(
  (route) => route
);
